import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  progress(id) {
    return axios.get(`${this.url}/${id}/progress`);
  }

  previewFilter(payload) {
    return axios.post(`${this.url}/preview_filter`, { payload });
  }

  previewLabels(labelIds) {
    return axios.post(`${this.url}/preview_labels`, { label_ids: labelIds });
  }

  previewCsv(blobSignedId) {
    return axios.post(`${this.url}/preview_csv`, {
      blob_signed_id: blobSignedId,
    });
  }
}

export default new CampaignsAPI();
